// accordion.js
//
// Works with any .accordion container. Each .accordion--button must have an
// aria-controls attribute pointing at its sibling .accordion--collapse element.
// Items toggle independently — opening one does not close others.
//
// Uses JS-driven max-height animation: on expand we set the element's
// max-height to its measured scrollHeight, then clear it after the transition
// so dynamic content (images loading, text reflowing) is not clipped.

function setCollapsed(target) {
    target.style.maxHeight = '0px';
    target.setAttribute('aria-hidden', 'true');
    target.classList.remove('show');
}

function setExpanded(target) {
    target.classList.add('show');
    target.setAttribute('aria-hidden', 'false');
    target.style.maxHeight = target.scrollHeight + 'px';

    function onEnd(e) {
        if (e.propertyName !== 'max-height') return;
        target.removeEventListener('transitionend', onEnd);
        // Only clear if we're still expanded — user may have re-clicked mid-transition.
        if (target.classList.contains('show')) {
            target.style.maxHeight = 'none';
        }
    }
    target.addEventListener('transitionend', onEnd);
}

function initAccordions() {
    var containers = document.querySelectorAll('.accordion');

    containers.forEach(function (container) {
        if (container.dataset.accordionInit === '1') return;
        container.dataset.accordionInit = '1';

        var buttons = container.querySelectorAll('.accordion--button');

        buttons.forEach(function (button) {
            var targetId = button.getAttribute('aria-controls');
            var target = targetId ? document.getElementById(targetId) : null;
            if (!target) return;

            // Ensure a known starting state.
            target.style.maxHeight = '0px';
            button.setAttribute('aria-expanded', 'false');
            target.setAttribute('aria-hidden', 'true');
            target.classList.remove('show');

            button.addEventListener('click', function () {
                var isExpanded = this.getAttribute('aria-expanded') === 'true';
                this.setAttribute('aria-expanded', !isExpanded);

                if (isExpanded) {
                    // Going from `max-height: none` back to a numeric value
                    // needs an explicit pixel value first or the transition
                    // won't fire.
                    if (target.style.maxHeight === 'none' || target.style.maxHeight === '') {
                        target.style.maxHeight = target.scrollHeight + 'px';
                        // Force a reflow so the browser registers the start value.
                        // eslint-disable-next-line no-unused-expressions
                        target.offsetHeight;
                    }
                    setCollapsed(target);
                } else {
                    setExpanded(target);
                }
            });
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
} else {
    initAccordions();
}
